import React from 'react'
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'
import { fontPalette } from '../../../../static/styles/global'

interface EarningsCardProps {
  navigation: any
  clockinStatusNum: number | undefined
  hasLaborSaver: number | boolean | undefined
  isActive: boolean | undefined
}

const EarningsCard = ({
  navigation,
  clockinStatusNum,
  hasLaborSaver,
  isActive
}: EarningsCardProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <View style={styles.card}>
      <View style={styles.headerRow}>
        <View style={styles.iconCircle}>
          <Ionicons name="card" size={16} color="white" />
        </View>
        <Text style={styles.headerTitle}>{t('Earnings')}</Text>
      </View>

      <View style={styles.listContainer}>
        {/* View Current Earnings */}
        {hasLaborSaver && isActive && (
          <TouchableOpacity
            style={styles.itemRow}
            onPress={() =>
              navigation.navigate('EarningsScreen', { clockinStatusNum })
            }
          >
            <View style={styles.itemLeft}>
              <View style={styles.itemIconBg}>
                <Ionicons name="cash-outline" size={18} color="#0B495C" />
              </View>
              <Text style={styles.itemText}>{t('View Current Earnings')}</Text>
            </View>
            <Ionicons name="chevron-forward" size={18} color="#CCCCCC" />
          </TouchableOpacity>
        )}

        {/* View Payroll Documents */}
        <TouchableOpacity
          style={styles.itemRow}
          onPress={() => navigation.navigate('PayrollDocuments')}
        >
          <View style={styles.itemLeft}>
            <View style={styles.itemIconBg}>
              <Ionicons name="document-text-outline" size={18} color="#0B495C" />
            </View>
            <Text style={styles.itemText}>{t('View Payroll Documents')}</Text>
          </View>
          <Ionicons name="chevron-forward" size={18} color="#CCCCCC" />
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default EarningsCard

const styles = StyleSheet.create({
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 16,
    marginVertical: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16
  },
  iconCircle: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: '#BEA02F',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: fontPalette.primaryBold,
    color: '#0B495C'
  },
  listContainer: {
    marginTop: 4
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0'
  },
  itemLeft: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  itemIconBg: {
    width: 32,
    height: 32,
    borderRadius: 6,
    backgroundColor: '#F0F7F9',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  itemText: {
    fontSize: 14,
    fontFamily: fontPalette.primarySemiBold,
    color: '#333'
  }
})
